import React from 'react';

export default function NameCell(cellData) {
  let code = cellData.data.code;
  let name = cellData.data.name;
  let target = cellData.data.targetGroup;

  return (
  <div>
    <div>{code ? code + ' | ' + name : name}</div>
    {target && <b>{`(${target})`}</b>}
  </div>
  );
}
